<template>
  <div class="image-upload">
    <label class="form-label">{{ label }}</label>
    <div class="d-flex fileImg">
      <img v-if="displayImage" :src="displayImage" width="0" height="0" />
      <input type="file" ref="fileInput" class="form-control hidden-upload-input" @change="onFileChange" />
    </div>

    <div v-if="displayImage" class="image-preview-wrap">
      <img :src="displayImage" alt="Image preview" @click="triggerFileInput" />
      <div class="remove-img-wrap">
        <button type="button" class="btn btn-sm btn-danger mt-2" @click="removeImage">Διαγραφή</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed } from "vue";

const props = defineProps({
  label: String,
  currentImage: String,
});
const emit = defineEmits(["file-selected", "remove-current-image"]);

const fileInput = ref(null);
const preview = ref(null);
const localFileSelected = ref(false);

const displayImage = computed(() => preview.value || props.currentImage);

watch(
  () => props.currentImage,
  (val) => {
    if (val) {
      preview.value = val;   
    } else {
      preview.value = null;  
    }
    localFileSelected.value = false;
  }
);




const triggerFileInput = () => fileInput.value?.click();

const onFileChange = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  localFileSelected.value = true;
  preview.value = URL.createObjectURL(file);
  emit("file-selected", file);
};

const removeImage = () => {
  preview.value = null;
  localFileSelected.value = false;
  fileInput.value.value = "";
  emit("remove-current-image");
};
</script>

<style>
  .image-preview-wrap{
    width:100%;
    height:150px;
    margin-bottom:35px;
  }

  .image-preview-wrap img {
    width: 100%;
    height: 100%;
    cursor:pointer;
    object-fit: cover;
  }

  .remove-img-wrap{
    text-align: right;
  }

  .remove-img-wrap button{
    color:#fff;
  }

  @media (max-width: 576px) {
    .image-preview-wrap{
      height: 80px;
    }  
  }
</style>
